import * as React from "react";

import "./top-control-modules.scss";

import {enableCanadaMailing} from "@Common/logic/enable-canada-mailing";
import {getCountryCode}      from "@Common/logic/template-options/get-country-code";
import {getMinQty}           from "@Common/logic/template-options/get-min-qty";
import {cs}                  from "@Common/react/chain-services";
import {consumeContext}      from "@Common/react/context";
import {itemEditor, ui}      from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";
import {MLListTable}         from "@Common/ui-components/heavy/mailing-ui/ml-list-table/ml-list-table";

import {AddressLists}               from "../../../../../common/address-lists/address-lists";
import {AddressableShippingOptions} from "../../../../../common/heavy/addressable-shipping-options/addressable-shipping-options";
import {MailingOptions}             from "../../../../../common/heavy/mailing-options/mailing-options";
import {NcoaFailed}                 from "../../../../../common/heavy/ncoa-failed/ncoa-failed";
import {onSaved}                    from "../common/on-saved-expo";

import {DedupePanel}         from "./ui/common/dedupe/dedupe-panel";
import {ShipAdditional}      from "./ui/ship-additional/ship-additional";
import {UnaddressedQuantity} from "./ui/unaddressed-quantity/unaddressed-quantity";

export const topControlModules = ({item, templateOptions,}) => [
    {
        load: (
            {
                method, mailingClass2, addressLists3, enableAddressableShippingLogic2, addressableShippingQuantity2,
                ncoaFailed2, quantityUi, shipAdditional, totalQuantity, paperPrices,
            },
            next,
        ) => cs(
            ["renderAddressLists", (_, next) => next(({showErrors, className, getExtraRows, translateError}) => cs(
                consumeContext("mailingLists"),
                ["isNDM", (_, next) => next(
                    !!(item?.metaData?.template?.isNDM)
                )], 
                ["mailingTable", ({mailingLists, isNDM}, next) => MLListTable({
                    itemId: item.itemId,
                    mailingListIds: addressLists3?.ui.state,
                    mailingLists,
                    isNDM,
                    showHeaderSummary: true,
                    countryCode: getCountryCode({templateOptions}),
                    eddmUnavailable: (
                        item?.programType === "Scheduled Campaigns" ||
                        !Object.keys(templateOptions?.mailingClasses??{}).some((mailingClassKey) => (
                            mailingClassKey === "3" || // standard
                            mailingClassKey === "5" // NDM
                        )) ||
                        false
                    ),
                    next,
                })],

                ({mailingTable}) => AddressLists({
                    errorMessages: addressLists3?.ui.errorMessages,
                    renderExtraOptions: addressLists3?.ui.dedupe && (() => DedupePanel({
                        dedupe: addressLists3.ui.dedupe,
                    })),
                    totalQuantity,
                    minQuantity: paperPrices && getMinQty(paperPrices),
                    getExtraRows,
                    className,
                    showErrors,
                    translateError,
                    mailingTable,
                }),
            ))],
            ({renderAddressLists}) => next({
                ui: method === "mailing" ? (
                    ({showErrors}) => cs(
                        consumeContext("session"),
                        consumeContext("company"),
                        ["hasEddm", ({session, company}, next) => next(
                            item?.programType !== "Scheduled Campaigns" &&
                            (!session.data.branch || session.data.branch.addressListTypes?.includes("saturation")) &&
                            company?.prefs?.addressListTypes?.includes("saturation")
                        )],                       
                        ["canadaMailing", (_, next) => enableCanadaMailing({templateOptions, next})],
                        ["allowAdditionalShipped", (_, next) => next(
                            !!(templateOptions?.allowAdditionalShipped)
                        )],
                        ({hasEddm, canadaMailing, allowAdditionalShipped}) => MailingOptions({
                            className: "top-control-modules-1k3 mailing-options",
                            mailingClass: {
                                state: mailingClass2?.ui.state,
                                forcedStandard: mailingClass2?.ui.forcedStandard,
                                mailingClassKeys: mailingClass2?.ui.mailingClassKeys,
                                hasEddm,
                                canadaMailing
                            },

                            renderAddressLists: () => renderAddressLists({
                                showErrors,
                                getExtraRows: () => (allowAdditionalShipped ? shipAdditional.renderRows({showErrors}) : ''),
                                className: "section top-control-modules-1k3 address-lists",
                            }),
                        }),
                    )
                ) : (method === "shipping" || method === "pickup") ? (
                    ({showErrors}) => cs(
                        ["unaddressedQuantity", (_, next) => UnaddressedQuantity({next})],
                        ({unaddressedQuantity}) => AddressableShippingOptions({
                            state: enableAddressableShippingLogic2?.ui,
                            subSections: addressLists3?.ui ? [
                                renderAddressLists({
                                    showErrors,
                                    className: "section top-control-modules-1k3 address-lists",

                                    getExtraRows: () => unaddressedQuantity.getRows({
                                        state: addressableShippingQuantity2?.ui,
                                        showErrors,
                                    }),
                                    translateError: (e) => e.code === "no_mailing_list_selected" ? (
                                        "Please select or create at least one address list or select the option to not print addresses to continue."
                                    ) : (
                                        e.errorMessage
                                    ),
                                }),
                                ncoaFailed2?.ui && (
                                    <div className="section">
                                        {NcoaFailed({
                                            ...ncoaFailed2.ui,
                                        })}
                                    </div>
                                ),
                            ] : [
                                <div className="section">
                                    {quantityUi.ui({showErrors})}
                                </div>
                            ],
                        })
                    )
                ) : (
                    null
                ),
            }),
        ),
        requires: [
            "method", "mailingClass2", "addressLists3", "enableAddressableShippingLogic2", "addressableShippingQuantity2",
            "ncoaFailed2", "quantityUi", "shipAdditional", "totalQuantity", "paperPrices",
        ],
        expo: [ui("topControl")],
    },

    {
        name: "shipAdditional",
        load: ({paperType1, method}, next) => ShipAdditional({
            paperType: paperType1.paperType,
            method,
            productAllowAdditionalShipped: templateOptions.allowAdditionalShipped,
            next,
        }),
        requires: ["paperType1", "method"],
        expo: [itemEditor, onSaved],
    }
];

